import { WSButton, WSText } from "@wingspanhq/fe-component-library";
import React from "react";
import { SetupFlowRouteComponentProps } from "../../../components/SetupFlow/SetupFlow";
import { PaymentsSetupLayout } from "../../../Invoices/components/PaymentsSetupLayout/PaymentsSetupLayout";
import { useEnterpriseQuery } from "../../../query/platform/queries";
import { WSQueries } from "../../../query/WSQuery";
import { useWSStore } from "../../../store";
import { openInNewTab } from "../../../utils/openInNewTab";

import styles from "./styles.module.scss";

export const Complete1099Onboarding: React.FC<SetupFlowRouteComponentProps> = ({
  onBack,
  onNext
}) => {
  const enterpriseQuery = useEnterpriseQuery();

  const onClickFAQ = () => {
    openInNewTab("https://wingspan.readme.io/docs/frequently-asked-questions");
  };

  return (
    <WSQueries queries={{ enterpriseQuery }}>
      {({ enterpriseQuery: { data: enterprise } }) => {
        return (
          <PaymentsSetupLayout
            title={`You're set up to receive your 1099 from ${enterprise.name}.`}
            onBack={onBack}
          >
            <WSText mt="L" mb="M">
              Your 1099 will be delivered by January 31st. You will receive a
              notification by email. Review the
              <WSText onClick={onClickFAQ} className={styles.faqLink}>
                frequently asked questions.
              </WSText>
            </WSText>
            <WSText mb="M">
              {enterprise.name}'s partnership with Wingspan provides you with
              free and optionals benefits like tax withholding, income tracking,
              identifying tax write-offs and more.
            </WSText>
            <WSButton.Secondary onClick={onNext} fullWidth>
              Explore Wingspan's benefits
            </WSButton.Secondary>
          </PaymentsSetupLayout>
        );
      }}
    </WSQueries>
  );
};
